
<div
  v-on="$listeners"
  class="editor-wrapper"
  @keydown.esc.capture="onEscape"
  :class="[
    styleType,
    {
      'single-line': isSingleLine,
      'no-heading-margins': noHeadingMargins,
      'is-readonly': isReadonly,
      'is-export': isExport,
      'placeholder-on-focus-only': showPlaceholderOnFocusOnly && !focused,
      'placeholder-hidden-on-focus': hidePlaceholderOnFocus
    }
  ]"
>
  <bubble-menu
    :editor="editor"
    v-if="useFloatingMenu && editor"
    :tippyOptions="tippyOptions"
    :should-show="shouldShowBubbleMenu"
  >
    <TextStylingBar
      :editor="editor"
      :showSend="false"
      :showOverlay="true"
      :hideActions="hideActions"
      :hideTextTypes="hideTextTypes"
    />
  </bubble-menu>
  <editor-content v-if="editor" :editor="editor" ref="editor" />
  <div
    v-else
    ref="staticRoot"
    class="ProseMirror static-content"
    v-html="staticContentHtml"
    @mousedown.capture="onStaticMousedown"
    @click.capture="onStaticClick"
    @mouseover="onStaticMouseover"
  />
</div>
